import React, { useState, useEffect } from 'react';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';

const CreateNewsModal = ({ isOpen, onClose, onSave, newsEvent }) => {
  const [formData, setFormData] = useState({
    title: '',
    categoryId: '',
    status: 'draft',
    headerImage: null,
    bodyImages: [],
  });
  const [content, setContent] = useState('');
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    const fetchCategories = async () => {
      const token = localStorage.getItem('token');
      const response = await fetch(`${process.env.REACT_APP_BASE_URL_API}/api/admin/news-categories`, {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });
      if (response.ok) {
        const data = await response.json();
        setCategories(data);
      }
    };
    if (isOpen) {
      fetchCategories();
    }
  }, [isOpen]);

  useEffect(() => {
    if (newsEvent) {
      setFormData({
        title: newsEvent.title,
        categoryId: newsEvent.categoryId,
        status: newsEvent.status,
        headerImage: null,
        bodyImages: [],
      });
      setContent(newsEvent.content);
    } else {
      setFormData({
        title: '',
        categoryId: '',
        status: 'draft',
        headerImage: null,
        bodyImages: [],
      });
      setContent('');
    }
  }, [newsEvent]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    if (name === 'headerImage') {
      setFormData({ ...formData, headerImage: files[0] });
    } else {
      setFormData({ ...formData, bodyImages: [...files] });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave({ ...formData, content });
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-gray-800 bg-opacity-75 flex items-center justify-center">
      <div className="bg-white rounded-lg shadow-lg p-8 max-w-2xl w-full max-h-[90vh] flex flex-col">
        <h2 className="text-2xl font-bold text-[#364A9A] mb-6 font-poppins">{newsEvent ? 'Edit' : 'Create'} News/Event</h2>
        <form onSubmit={handleSubmit} className="space-y-4 overflow-y-auto">
          <div>
            <label htmlFor="title" className="block text-gray-700 font-bold mb-2">Title</label>
            <input
              type="text"
              id="title"
              name="title"
              value={formData.title}
              onChange={handleInputChange}
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#364A9A]"
              required
            />
          </div>
          <div>
            <label htmlFor="content" className="block text-gray-700 font-bold mb-2">Content</label>
            <ReactQuill theme="snow" value={content} onChange={setContent} />
          </div>
          <div>
            <label htmlFor="categoryId" className="block text-gray-700 font-bold mb-2">Category</label>
            <select
              id="categoryId"
              name="categoryId"
              value={formData.categoryId}
              onChange={handleInputChange}
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#364A9A]"
              required
            >
              <option value="">Select a category</option>
              {categories.map(category => (
                <option key={category.id} value={category.id}>{category.name}</option>
              ))}
            </select>
          </div>
          <div>
            <label htmlFor="status" className="block text-gray-700 font-bold mb-2">Status</label>
            <select
              id="status"
              name="status"
              value={formData.status}
              onChange={handleInputChange}
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#364A9A]"
              required
            >
              <option value="draft">Draft</option>
              <option value="published">Published</option>
            </select>
          </div>
          <div>
            <label htmlFor="headerImage" className="block text-gray-700 font-bold mb-2">Header Image</label>
            <input
              type="file"
              id="headerImage"
              name="headerImage"
              onChange={handleFileChange}
              className="w-full"
            />
          </div>
          <div>
            <label htmlFor="bodyImages" className="block text-gray-700 font-bold mb-2">Body Images</label>
            <input
              type="file"
              id="bodyImages"
              name="bodyImages"
              onChange={handleFileChange}
              multiple
              className="w-full"
            />
          </div>
          <div className="text-right mt-6">
            <button
              type="button"
              onClick={onClose}
              className="bg-gray-500 text-white font-bold py-2 px-4 rounded-lg mr-2"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="bg-green-500 text-white font-bold py-2 px-4 rounded-lg"
            >
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateNewsModal;
